<template>
  <main class="app-main">
    <div class="app-content-header">
      <div class="container-fluid">
        <div class="row">
          <div class="col-sm-6"><h3 class="mb-0">{{ rowTitle }}</h3></div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-end">
              <li class="breadcrumb-item"><router-link to="/">الرئيسية</router-link></li>
              <li class="breadcrumb-item"><router-link to="/restoreAccounts">طلبات استرداد الحسابات</router-link></li>
              <li class="breadcrumb-item active" aria-current="page">{{ rowTitle }}</li>
            </ol>
          </div>
        </div>
      </div>
    </div>

    <div class="app-content">
      <div class="container-fluid">
        <div class="row justify-content-center">
          <div class="col-12 col-sm-10">
            <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
            <mainLoader v-if="mainLoading" />
            <RestoreAccountsForm
              v-if="!mainLoading"
              :cardTitle="rowTitle"
              :dataRow="row"
            />
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { checkAccess } from '@/helpers/tools';
import RestoreAccountsForm from './form.vue';

export default {
  name: 'RestoreAccountsUpdate',
  components: {
    RestoreAccountsForm,
  },
  data() {
    return {
      id: this.$route.params.id,
      mainLoading: true,
      hasError: false,
      message: '',
      errorNumber: 0,
      rowTitle: 'طلب استرداد حساب',
      row: null,
    };
  },
  methods: {
    checkAccess,
    getRowData() {
      this.$http.get(`/api/admin/restoreAccounts/retrieve/${this.id}`).then(({ data }) => {
        this.row = data.row;
        this.rowTitle = `طلب استرداد حساب #${this.row.id} — ${this.row.mobile}`;
        this.mainLoading = false;
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        this.mainLoading = false;
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    },
  },
  created() {
    this.getRowData();
  },
};
</script>